import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

/** Faixa no topo quando o celular perde a internet: nada do que está na tela se perde. */
export function AvisoConexao() {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  if (online) return null;
  return (
    <div
      role="status"
      className="flex items-center gap-2 rounded-md border border-warning/50 bg-warning/15 px-3 py-2 text-sm"
    >
      <WifiOff className="size-4 shrink-0" aria-hidden />
      Sem internet. Pode continuar preenchendo: o que você digitou fica guardado e é enviado quando
      você tentar de novo com sinal.
    </div>
  );
}
